import { Box, Button, CircularProgress } from '@mui/material';
import { useFormState } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';

export function FormActions({
  saveLabel,
  disableOnSubmit = false,
}: {
  saveLabel?: string;
  disableOnSubmit?: boolean;
}) {
  const { $t } = useIntl();
  const state = useFormState();
  const loading = state.isSubmitting || (disableOnSubmit && state.isSubmitted);

  const resolvedSaveLabel =
    saveLabel ??
    $t({
      id: 'common.form.saveBtnText',
      defaultMessage: 'Guardar',
    });

  return (
    <Box>
      <Button
        variant="outlined"
        color="primary"
        type="submit"
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
      >
        {resolvedSaveLabel}
      </Button>
    </Box>
  );
}
